
function feedMixCards() {

    mixCards.forEach((mixCard) => {
       
        const mixCardCircle = mixCard.querySelector('.js-mix-card-circle');
        const mixRotate = gsap.timeline({ paused:true, repeat:-1 });

        mixRotate.to(mixCardCircle, 10, { rotation:"+=360",ease:Linear.easeNone } )

        mixCard.addEventListener("mouseenter", () => {
            mixRotate.play();
        });

        mixCard.addEventListener("mouseleave", () => {
            mixRotate.pause();
        });
    });

}

